define([
	"dojo/_base/declare",
	"csi/_base/underscore",
	"csi/action/FormData",
	"csi/action/SelectOneController",
	"csi/xml"
], function(declare,_,FormData,SelectOneController,xml) {
	return declare(SelectOneController, {
		getFormData: function() {
			var	data = this.inherited(arguments);
			data.m_bSelectOne = true;
			data.m_bRequireOne = true;
			return data;
		}
	});
});
